// @ts-nocheck
import React, { memo } from 'react'
import { Checkbox as checkbox } from 'components/forms'
import {
  InsuranceSelect as select,
  InsuranceAmount as amount,
  InsuranceExpiration as expiration,
  InsuranceRadio as radio,
  InsuranceEmail as email,
  InsurancePhone,
  useHandlers,
} from './atoms'
import { IPhoneProps } from './atoms/InsurancePhone'
import { IDefaultValue } from './atoms/useFallback'

const componentTypes = {
  select,
  amount,
  expiration,
  radio,
  email,
  phone: ({ defaultValue, id, onChange, value }: IPhoneProps) => (
    <InsurancePhone
      id={id}
      value={value}
      onChange={onChange}
      defaultValue={defaultValue}
      type='phone'
    />
  ),
  fax: ({ defaultValue, id, onChange, value }: IPhoneProps) => (
    <InsurancePhone
      id={id}
      value={value}
      onChange={onChange}
      defaultValue={defaultValue}
      type='fax'
    />
  ),
  checkbox,
}

type InputTypes =
  | 'select'
  | 'amount'
  | 'expiration'
  | 'radio'
  | 'email'
  | 'phone'
  | 'fax'
  | 'checkbox'
  | 'value'

interface IInsuranceDialogSectionProps {
  title: string
  insuranceType: string
  onChange: (...args: any[]) => any
  rows: {
    type: InputTypes
    key?: string
    label?: string
    options?: { label: string; value: string }[]
    value?: string | boolean
    defaultValue?: IDefaultValue
  }[][]
  contactInfo?: {
    email?: string
    phone?: string
    fax?: string
  }
}

const InsuranceDialogSection: React.FunctionComponent<IInsuranceDialogSectionProps> = memo(
  ({ contactInfo, insuranceType, onChange, rows, title }) => {
    const {
      onAmountChange,
      onCheckboxChange,
      onContactInfoChange,
      onExpirationChange,
      onRadioChange,
      onSelectChange,
    } = useHandlers(insuranceType, onChange, contactInfo)
    const handlers = {
      select: onSelectChange,
      amount: onAmountChange,
      expiration: onExpirationChange,
      radio: onRadioChange,
      email: onContactInfoChange,
      phone: onContactInfoChange,
      fax: onContactInfoChange,
      checkbox: onCheckboxChange,
    }
    return (
      <>
        <div className='pv2'>
          <h3>{title}</h3>
        </div>
        {rows.map(items => {
          const rowKey = items.map(({ key }) => key).join('-')
          return (
            <div className='row' key={rowKey}>
              {items.map(({ defaultValue, key, label, options, type, value }) => {
                const Component = componentTypes[type]
                const id = `${insuranceType}-${key}`
                const { checked: componentChecked, value: componentValue } = {
                  [type === 'checkbox' ? 'checked' : 'value']: value,
                }
                return (
                  <div className='col-md-6' key={key}>
                    <div className={`row collapse ${type === 'checkbox' ? 'col-xs-12' : ''}`}>
                      <Component
                        key={key}
                        id={id}
                        dataTest={id}
                        label={label}
                        defaultValue={defaultValue}
                        onChange={handlers[type]}
                        options={options}
                        checked={componentChecked}
                        value={componentValue}
                      />
                    </div>
                  </div>
                )
              })}
            </div>
          )
        })}
      </>
    )
  }
)

export default InsuranceDialogSection
